export default __webpack_public_path__ + "static/media/close.1ae456d2.svg";